import { DropdownListViewModel, ValueFormField } from '@sitecore-jss/sitecore-jss-forms';
import { FieldChangeCallback, Label, ListFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import { FC, Fragment } from 'react';

import { FieldValidationErrors } from '../CustomFields/FieldValidationErrors';
import { getFormFieldAriaProps } from '../Functions/FormFieldAriaProps';

/**
 * Overrides the built-in Sitecore forms dropdown list.
 * @see [Original DropdownList Implementation](https://github.com/Sitecore/jss/blob/v22.10.0/packages/sitecore-jss-react-forms/src/components/field-templates/dropdown-list.tsx)
 *
 * Markup and functionality should be 1:1 with the exception of `getFormFieldAriaProps`.
 *
 * @param props - DropdownList properties.
 * @returns A dropdown list.
 */
export const BaseDropdownList: FC<ListFieldProps<DropdownListViewModel>> = (props) => {
  const { errors, field, onChange, tracker, value } = props;

  return (
    <Fragment>
      <Label {...props} />
      <select
        className={field.model.cssClass}
        id={field.valueField.id}
        name={field.valueField.name}
        value={value[0]}
        onChange={(e) => handleOnChange(field, e.target.value, onChange)}
        onFocus={() => tracker.onFocusField(field, value)}
        onBlur={() => tracker.onBlurField(field, value, errors)}
        {...getFormFieldAriaProps(field, errors)}
      >
        {field.model.showEmptyItem ? <option label=" " /> : null}
        {field.model.items.map((item) => (
          <option key={item.itemId} value={item.value}>
            {item.text}
          </option>
        ))}
      </select>
      <FieldValidationErrors {...props} />
    </Fragment>
  );
};

function handleOnChange(field: ValueFormField, newValue: string, callback: FieldChangeCallback) {
  const errorMessages = [];
  let valid = true;

  if (field.model.required && !newValue) {
    errorMessages.push(`${field.model.title} is required`);
    valid = false;
  }

  callback(field.valueField.name, [newValue], valid, errorMessages);
}
